export default __webpack_public_path__ + "static/media/userimg1.f7879c77.png";